<ng-container *ngIf="{ rtlDir: rtlDir$ | async } as vm">
  <nav
    [attr.aria-label]="'ariaLabels.MAIN_NAVIGATION' | translate"
    class="navigation"
  >
    <ng-container *ngIf="adminMenuItems$ | async as adminMenuItems">
      <ng-container
        *ngIf="!!adminMenuItems.length"
        [ngTemplateOutlet]="menu"
        [ngTemplateOutletContext]="{
          menu: adminMenuItems,
          testId: 'adminMenu',
        }"
      ></ng-container>
      <hr class="mx-4 my-0" *ngIf="!!adminMenuItems.length" />
    </ng-container>
    <app-my-spaces-list *ngIf="!hasActiveDelegation" class="m-2" />
    <ng-container *ngIf="servicesMenuItems$ | async as servicesMenuItems">
      <ng-container
        [ngTemplateOutlet]="menu"
        [ngTemplateOutletContext]="{
          menu: servicesMenuItems,
          testId: 'servicesMenu',
        }"
      ></ng-container>
      <hr class="mx-4 my-0" *ngIf="servicesMenuItems?.length" />
    </ng-container>

    <div *ngIf="menuItems$ | async as menuItems" class="scroll-v menu-items">
      <ng-container
        *ngIf="!!menuItems.length"
        [ngTemplateOutlet]="menu"
        [ngTemplateOutletContext]="{ menu: menuItems, testId: 'menuItems' }"
      ></ng-container>
    </div>
  </nav>

  <ng-template #menu let-menu="menu" let-testId="testId">
    <ul
      *ngIf="menu?.length"
      class="layout-menu !pb-0 admin-menu"
      role="menu"
      [attr.data-testid]="testId"
    >
      <ng-container
        *ngFor="let item of menu; let i = index; trackBy: trackByFn"
      >
        <li
          role="menuitem"
          menu-item
          [item]="item"
          [index]="i"
          [root]="true"
          [rtlDir]="vm.rtlDir"
          [ngClass]="item.styleClass"
        ></li>
      </ng-container>
    </ul>
  </ng-template>
</ng-container>
